import React, { Component, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import './App.css';
import './common.css';
import './assets/css/icon-fonts.css';
import './assets/css/bombiix-icons.css';
import './assets/scss/master-design.scss';
import { ReactNotifications } from 'react-notifications-component';
import history from './history';
import { PrivateRoutes, PublicRoutes } from './routes';
import Loader from './Components/Utility/Loader/Loader';
import { loadUser } from './Pages/Auth/store/Auth.action';
import mainStore from './store';
import { fetchLogInRights, getSubscriptionDetails } from './Pages/UserSetting/store/User.action';
import { fetchCompanyRights } from './Pages/CompanyRights/store/Companyrights.action';
import { AutoIdGenerator } from './Pages/SystemMasters/Store/SystemMasters.action';
import OfflineBanner from './Components/OfflineBanner/OfflineBanner';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { userInfo: null, loading: true };
  }

  async componentWillMount() {
    const userInfo = await mainStore.store.dispatch(loadUser());

    if (window.location.hash.includes('#')) {
      const newUrl = window.location.href.replace('#', '');
      window.location.replace(newUrl);
    }
    if (userInfo) {
      const payload = {
        section: 'all',
      };
      await mainStore.store.dispatch(getSubscriptionDetails());
      const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
      const loggedInDataObj = { ...user };
      let shouldPersistLoggedInData = false;
      if (user?.lengthVisible === undefined || user?.lengthVisible === null) {
        loggedInDataObj.lengthVisible = userInfo?.lengthVisible || true;
        shouldPersistLoggedInData = true;
      }
      if (user?.variableOneName === undefined || user?.variableOneName === null) {
        loggedInDataObj.variableOneName = userInfo?.variableOneName || 'Lengths';
        shouldPersistLoggedInData = true;
      }
      if (shouldPersistLoggedInData) {
        localStorage.setItem('loggedInUserInfo', JSON.stringify(loggedInDataObj));
      }
      if (user?.role === 'User' || user?.role === 'Supplier' || user?.role === 'SupplierUser') {
        await mainStore.store.dispatch(fetchLogInRights(payload));
      }

      await mainStore.store.dispatch(fetchCompanyRights());
      await mainStore.store.dispatch(AutoIdGenerator());
      this.setState({
        userInfo,
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }

    // Update root element class based on user login status
    this.updateRootClass(userInfo);
    const LogRoutesArr = ['submit-download-log-permission', 'all-submit-download-log-permission'];
    if (window?.location?.pathname?.split('/').some((i) => LogRoutesArr.includes(i))) {
      return <PublicRoutes />;
    }
    if (!userInfo) {
      const PublicRoutesArr = [
        'product-costing-supplier',
        'submit-download-logs',
        'supplier-component-order',
        'product-purchase-order',
        'change-password',
        'forgot-password',
        'set-security-question',
        'login',
        'set-new-password',
        'suppliers-register',
        'register-user',
        'answer-security-question',
        'setup2fa',
        'verify-code',
        'supplier-account-details',
        'multi-submit-download-logs',
        'user-confirm',
      ];

      if (!window?.location?.pathname?.split('/').some((i) => PublicRoutesArr.includes(i))) {
        window.location.assign(`${window.location.origin}/login`);
      }
    }

    if (userInfo) {
      const PublicRoutesArr = [
        'product-costing-supplier',
        'submit-download-logs',
        'supplier-component-order',
        'product-purchase-order',
        'change-password',
        'forgot-password',
        'set-security-question',
        'login',
        'set-new-password',
        'suppliers-register',
        'register-user',
        'answer-security-question',
        'setup2fa',
        'verify-code',
        'supplier-account-details',
        'multi-submit-download-logs',
        'user-confirm',
      ];

      if (
        !window?.location?.pathname?.split('/').some((i) => PublicRoutesArr.includes(i)) &&
        !userInfo?.masterPasswordMatched &&
        userInfo.mfaEnabled &&
        !userInfo.mfaVerified
      ) {
        window.location.assign(`${window.location.origin}/verify-code`);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Update root class if userInfo state changes
    if (prevState.userInfo !== this.state.userInfo) {
      this.updateRootClass(this.state.userInfo);
    }
  }

  // Method to update root element class based on user login status
  updateRootClass(userInfo) {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      if (!userInfo) {
        // User is not logged in - add p-0 class
        if (!rootElement.classList.contains('p-0')) {
          rootElement.classList.add('p-0');
        }
      } else {
        // User is logged in - remove p-0 class
        rootElement.classList.remove('p-0');
      }
    }
  }

  renderCompoennt() {
    const PublicRoutesArr = [
      'submit-download-log-permission',
      'supplier-component-order',
      // "product-purchase-order",
      'change-password',
      'forgot-password',
      'set-security-question',
      'set-new-password',
      'login',
      'suppliers-register',
      'register-user',
      'answer-security-question',
      'setup2fa',
      'verify-code',
      'product-costing-supplier',
      'supplier-account-details',
      'multi-submit-download-logs',
      'all-submit-download-log-permission',
      'user-confirm',
    ];
    if (window?.location?.pathname.includes('/sub-supplier/purchase-order/')) {
      localStorage.setItem('redirectToPO', window?.location?.pathname);
    }
    if (window?.location?.pathname.includes('/order-po-template')) {
      const searchParams = new URLSearchParams(window?.location?.search);
      const createPoId = searchParams.get('createPoId');
      const parts = window?.location?.pathname?.split('/') ?? [];
      const devOrderIndex = parts.indexOf('development-order');
      const devorder = devOrderIndex !== -1 ? parts[devOrderIndex + 1] : null;
      const poIdFromPath = devOrderIndex !== -1 ? parts[devOrderIndex + 3] : null;
      const resolvedPoId = createPoId ?? poIdFromPath;
      if (devorder && resolvedPoId) {
        localStorage.setItem('redirectionToPO', `${window?.location.origin}/development-order/${devorder}/order-po-template/${resolvedPoId}`);
      }
    }
    if (window?.location?.pathname.includes('/public-product-purchase-order')) {
      const searchParams = new URLSearchParams(window?.location?.search);
      const createPoId = searchParams.get('pId') || searchParams.get('createPoId');
      const devorder = searchParams.get('dId') || window?.location?.pathname?.split('/')[3];
      if (devorder && createPoId) {
        localStorage.setItem('redirectionToPO', `${window?.location.origin}/react-app/development-order/${devorder}/product-purchase-order/edit/${createPoId}`);
      }
    }

    const alwaysPublicRoutes = ['submit-download-log-permission', 'all-submit-download-log-permission'];
    if (window?.location?.pathname?.split('/').some((i) => alwaysPublicRoutes.includes(i))) {
      return <PublicRoutes />;
    }

    if (this.state.userInfo) {
      const user = this.state.userInfo;
      const pendingMfa = user.mfaEnabled && !user.mfaVerified && !user.masterPasswordMatched;
      if (pendingMfa) {
        return <PublicRoutes />;
      }
      return <PrivateRoutes history={history} role={this.state.userInfo.role} />;
    }
    if (window?.location?.pathname?.split('/').some((i) => PublicRoutesArr.includes(i))) {
      return <PublicRoutes />;
    }
  }

  render() {
    return (
      <Router history={history} basename={process.env.PUBLIC_URL}>
        <ReactNotifications />
        <OfflineBanner />
        <Suspense fallback={<Loader />}>{!this.state.loading ? this.renderCompoennt() : <Loader />}</Suspense>
      </Router>
    );
  }
}

const mapStateToProps = ({ UserDetails }) => {
  return {
    userInfo: UserDetails.userInfo,
  };
};

export default connect(mapStateToProps)(App);
